/**
 * Wishlist Collection Button - Global Script (Event Delegation)
 * Handles all wishlist add/remove buttons on product cards via a single
 * set of event listeners instead of per-card inline scripts.
 */
(function () {
  var initialized = false;

  function getWrapper(el) {
    return el.closest('.wishlist-collection-wrapper');
  }

  function getProductData(wrapper, wishListHash) {
    return {
      ProductId: parseInt(wrapper.dataset.productId, 10),
      ProductTitle: wrapper.dataset.productTitle,
      ProductPrice: parseFloat(wrapper.dataset.productPrice),
      ProductLink: wrapper.dataset.productUrl,
      ProductImage: wrapper.dataset.productImage,
      ProductHandle: wrapper.dataset.productHandle,
      ProductVariantId: parseInt(wrapper.dataset.variantId, 10),
      ProductVariantTitle: wrapper.dataset.variantTitle,
      WishlistHash: wishListHash,
    };
  }

  function showAdd(wrapper) {
    var add = wrapper.querySelector('.wishlist-btn-add');
    var remove = wrapper.querySelector('.wishlist-btn-remove');
    if (add) add.style.display = 'flex';
    if (remove) remove.style.display = 'none';
  }

  function showRemove(wrapper) {
    var add = wrapper.querySelector('.wishlist-btn-add');
    var remove = wrapper.querySelector('.wishlist-btn-remove');
    if (add) add.style.display = 'none';
    if (remove) remove.style.display = 'flex';
  }

  async function checkAllWishlistButtons() {
    if (typeof WishListHero_SDK === 'undefined' || !WishListHero_SDK.GetWishListItemsFromServer) {
      return;
    }

    try {
      var result = await WishListHero_SDK.GetWishListItemsFromServer();
      var items = Array.isArray(result) ? result : (result?.items || result?.data || []);

      var wrappers = document.querySelectorAll('.wishlist-collection-wrapper');
      wrappers.forEach(function (wrapper) {
        var variantId = parseInt(wrapper.dataset.variantId, 10);
        var productId = parseInt(wrapper.dataset.productId, 10);

        var isInWishlist = items.some(function (item) {
          var itemVariantId = parseInt(item.ProductVariantId, 10);
          var itemProductId = parseInt(item.ProductId, 10);
          return itemVariantId === variantId || itemProductId === productId;
        });

        if (isInWishlist) {
          showRemove(wrapper);
        } else {
          showAdd(wrapper);
        }
      });
    } catch (error) {
      console.error('Error checking wishlist:', error);
    }
  }

  function initWishlistGlobal() {
    if (initialized) return;
    initialized = true;

    // Show all wrappers
    var wrappers = document.querySelectorAll('.wishlist-collection-wrapper');
    wrappers.forEach(function (w) {
      w.style.display = 'flex';
    });

    // Event delegation for add buttons
    document.addEventListener('click', async function (e) {
      var addBtn = e.target.closest('.wishlist-btn-add');
      if (!addBtn) return;

      e.preventDefault();
      e.stopPropagation();

      var wrapper = getWrapper(addBtn);
      if (!wrapper) return;

      if (typeof WishListHero_SDK === 'undefined' || !WishListHero_SDK.AddWishListItem) {
        console.error('WishListHero_SDK not available');
        return;
      }

      var customerId = WishListHero_SDK.GetCustomerId();
      if (!customerId) {
        WishListHero_SDK.OpenWishList();
        return;
      }

      var removeBtn = wrapper.querySelector('.wishlist-btn-remove');
      if (removeBtn && removeBtn.style.display === 'flex') return;

      try {
        var wishListHash = await WishListHero_SDK.GetWishListHash(true);
        var productData = getProductData(wrapper, wishListHash);
        var added = await WishListHero_SDK.AddWishListItem(productData);

        if (added?.ok) {
          if (window.AlgoliaHelpers?.invalidateWishlistCache) {
            window.AlgoliaHelpers.invalidateWishlistCache();
          }
          showRemove(wrapper);
          document.dispatchEvent(new CustomEvent('wishlist:updated'));
        } else if (added?.error === 'item already exists!') {
          showRemove(wrapper);
        } else {
          console.error('Error adding product:', added);
        }
      } catch (error) {
        console.error('Error adding to wishlist:', error);
      }
    });

    // Event delegation for remove buttons
    document.addEventListener('click', async function (e) {
      var removeBtn = e.target.closest('.wishlist-btn-remove');
      if (!removeBtn) return;

      e.preventDefault();
      e.stopPropagation();

      var wrapper = getWrapper(removeBtn);
      if (!wrapper) return;

      if (typeof WishListHero_SDK === 'undefined' || !WishListHero_SDK.DeleteWishListItem) {
        console.error('WishListHero_SDK not available');
        return;
      }

      try {
        var wishListHash = await WishListHero_SDK.GetWishListHash();
        var productData = {
          ProductVariantId: parseInt(wrapper.dataset.variantId, 10),
          WishlistHash: wishListHash,
        };
        var removed = await WishListHero_SDK.DeleteWishListItem(productData);

        if (removed?.ok) {
          if (window.AlgoliaHelpers?.invalidateWishlistCache) {
            window.AlgoliaHelpers.invalidateWishlistCache();
          }
          showAdd(wrapper);
          document.dispatchEvent(new CustomEvent('wishlist:updated'));
        } else {
          console.error('Error removing product:', removed);
        }
      } catch (error) {
        console.error('Error removing from wishlist:', error);
      }
    });

    // Initial check
    checkAllWishlistButtons();

    // Listen for wishlist updates
    document.addEventListener('wishlisthero.product.added', checkAllWishlistButtons);
    document.addEventListener('wishlisthero.product.removed', checkAllWishlistButtons);
    document.addEventListener('wishlist:updated', checkAllWishlistButtons);
  }

  // Listen for the SDK ready event
  document.addEventListener('wishlist-hero-wishlist-sdk-ready', initWishlistGlobal);

  // Also initialize if SDK is already available
  if (typeof WishListHero_SDK !== 'undefined' && WishListHero_SDK.AddWishListItem) {
    setTimeout(initWishlistGlobal, 100);
  }
})();
